<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right"></div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'settings.version.title' | translate }} {{ 'settings.version.number' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span [innerHTML]="'settings.version.details' | translate"></span>
        </h2>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin12 ir-cell-sma12 ir-cell-mid12 ir-cell-lar12">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="close()"
          >
            <span>{{ 'common.close' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
